import React, { useState } from 'react';
import { alpha, useTheme } from '@mui/material/styles';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Avatar from 'ui-component/extended/Avatar';
import Loader from 'ui-component/Loader';
import NoResultsFound from 'Application/components/NoResultsFound';
import { IconButton, Tooltip } from '@mui/material';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import EditIcon from '@mui/icons-material/Edit';
import { useCreateUserStore } from 'Application/store';
import { IconUserCheck } from '@tabler/icons-react';
import AppDialog from 'Application/components/Modals/AppDialog';
import Lottie from 'react-lottie';
import SuccessAnime from 'assets/lottie/waiting.json';
import { toast } from 'sonner';
import { ManagedUser, UpdateUserRequest, UserRole } from 'Application/models';
import EditAgencyUser from 'Application/components/Modals/EditAgencyUser';
import { ThemeMode } from 'config';
// import { UsersData } from 'Application/data/UsersData';

interface UsersListProps {
    searchTerm: string;
    currentPage: number;
    rowsPerPage: number;
    name: string;
    data: any[];
    openState: {
        dialog: { open: boolean; setOpen: (open: boolean) => void };
        modal: { open: boolean; setOpen: (open: boolean) => void };
    };
    onEditUser: (user: UpdateUserRequest) => void;
}

interface UserStatus {
    name: string;
    email: string;
    locked: boolean;
}

const roleMapping: Record<string, string> = {
    ROLE_AGENT: 'Agent',
    ROLE_AGENCY_ADMIN: 'Agency Admin'
    // Add more role mappings as needed
};

export const BritamAgencyAdminUsers: React.FC<UsersListProps> = ({
    name: agencyName,
    data: agencyUserData,
    openState,
    onEditUser,
    searchTerm,
    currentPage,
    rowsPerPage
}) => {
    const theme = useTheme();
    // const [searchTerm, setSearchTerm] = useState<string>('');
    // const [currentPage, setCurrentPage] = useState<number>(1);
    // const [rowsPerPage, setRowsPerPage] = useState<number>(15);
    // //edit user
    const [editUserId, setEditUserId] = useState<number>();
    // const [isEditUserDialogOpen, setIsEditUserDialogOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState<UpdateUserRequest | null>(null);
    const [selectedUserRole, setSelectedUserRole] = useState<UserRole>(() => UserRole.ROLE_AGENCY_ADMIN);

    const [userStatus, setUserStatus] = useState<UserStatus | null>(null);

    const { modal, dialog } = openState;

    // Zustand store
    const { activateUser, deactivateUser, isAgencyUsersLoading, getAgecyUsersList } = useCreateUserStore();

    if (!agencyUserData) {
        return <Loader />;
    }

    // Ensure agencyUserData is an array
    const users = Array.isArray(agencyUserData) ? agencyUserData : [];

    //check edituserid and match with user id from users list
    const userSelect = users.find((user) => user.id === editUserId);

    if (users.length === 0) {
        return <NoResultsFound title="No results found" />;
    }

    // Filter and paginate user data
    const filteredUsers = users.filter((user) => `${user.firstName} ${user.lastName}`.toLowerCase().includes(searchTerm.toLowerCase()));

    const paginatedUsers = filteredUsers.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

    const formatRoles = (roleString: string) => {
        return roleString
            .split(',')
            .map((role) => roleMapping[role] || role)
            .join(', ');
    };

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: SuccessAnime,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    const handleClose = () => {
        dialog.setOpen(false);
    };

    const handleOpen = (user: UserStatus) => {
        dialog.setOpen(true);
        setUserStatus(user);
    };

    const handleEditUser = async (user: ManagedUser, event?: React.FormEvent) => {
        event?.preventDefault();
        event?.stopPropagation();

        const updatedUser: UpdateUserRequest = {
            firstName: user.firstName,
            otherNames: user.lastName,
            emailAddress: user.emailAddress
        };
        setSelectedUser(updatedUser);
        // setIsEditUserDialogOpen(true);
        modal.setOpen(true);
        setEditUserId(user.id);
        setSelectedUserRole(user?.role?.roleName as UserRole);

        //fetch agency users

        handleClose();
    };

    const handleConfirm = async () => {
        if (!userStatus) {
            handleClose();
            return;
        }

        if (userStatus.locked) {
            await activateUser(userStatus.email);
            await getAgecyUsersList(agencyName);
            toast.success('User activated successfully');
            // TODO: Display toast messages when user is activated/deactivated successfully
            // if (activateUserData) toast.success(activateUserData.message);
        } else {
            await deactivateUser(userStatus.email);
            await getAgecyUsersList(agencyName);
            toast.success('User deactivated successfully');
            // if (deactivateUserData) toast.success(deactivateUserData.message);
        }

        handleClose();
    };
    console.log('selected user', selectedUser);
    console.log('editting user', editUserId);

    return (
        <TableContainer>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell sx={{ pl: 3 }}>Name</TableCell>
                        <TableCell>Role</TableCell>
                        <TableCell>Date Created</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell align="center" sx={{ pr: 3 }}>
                            Actions
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {paginatedUsers?.map((user, index) => {
                        console.log(user?.intermediary?.name, 'user');
                        console.log(user?.role?.roleName, 'user role');
                        const userBelongsToAgency = user?.intermediary?.name === agencyName;
                        console.log(userBelongsToAgency, 'userBelongsToAgency');
                        if (!userBelongsToAgency) {
                            return null;
                        }
                        const firstNameInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '?';
                        const lastNameInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '?';

                        return (
                            <TableRow hover key={index}>
                                <TableCell sx={{ pl: 3 }}>
                                    <Stack direction="row" alignItems="center" spacing={2}>
                                        <Avatar sx={{ fontSize: '0.9rem' }} alt={`${user.firstName || 'N/A'} ${user.lastName || 'N/A'}`}>
                                            {firstNameInitial}
                                            {lastNameInitial}
                                        </Avatar>
                                        <Stack>
                                            <Typography variant="subtitle1">
                                                {user.firstName} {user.lastName}
                                            </Typography>
                                            <Typography variant="subtitle2" noWrap>
                                                {user.emailAddress}
                                            </Typography>
                                        </Stack>
                                    </Stack>
                                </TableCell>
                                <TableCell>{formatRoles(user.role.roleName)}</TableCell>
                                <TableCell>{new Date(user.createdAt).toLocaleDateString()}</TableCell>
                                <TableCell>
                                    {!user.locked ? (
                                        <Chip
                                            label="Active"
                                            size="small"
                                            sx={{
                                                bgcolor: theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'success.light',
                                                color: 'success.dark'
                                            }}
                                        />
                                    ) : (
                                        <Chip
                                            label="Inactive"
                                            size="small"
                                            sx={{
                                                bgcolor:
                                                    theme.palette.mode === ThemeMode.DARK
                                                        ? 'dark.main'
                                                        : alpha(theme.palette.error.light, 0.6),
                                                color: 'error.dark'
                                            }}
                                        />
                                    )}
                                </TableCell>
                                <TableCell align="center" sx={{ pr: 3 }}>
                                    <Stack direction="row" justifyContent="center" alignItems="center">
                                        <Tooltip placement="top" title="Edit">
                                            <IconButton color="primary" aria-label="edit" size="large" onClick={() => handleEditUser(user)}>
                                                <EditIcon sx={{ fontSize: '1.1rem' }} />
                                            </IconButton>
                                        </Tooltip>
                                        <Tooltip
                                            placement="top"
                                            title={user.locked ? 'Activate' : 'Deactivate'}
                                            onClick={() =>
                                                handleOpen({
                                                    name: `${user.firstName} ${user.lastName}`,
                                                    email: user.emailAddress,
                                                    locked: user.locked
                                                })
                                            }
                                        >
                                            <IconButton
                                                color="primary"
                                                sx={
                                                    user.locked
                                                        ? {
                                                              color: 'success.dark',
                                                              borderColor: 'success.main',
                                                              '&:hover ': { bgcolor: 'success.light' }
                                                          }
                                                        : {
                                                              color: 'orange.dark',
                                                              borderColor: 'orange.main',
                                                              '&:hover ': { bgcolor: 'orange.light' }
                                                          }
                                                }
                                                size="large"
                                            >
                                                {user.locked ? (
                                                    <IconUserCheck stroke={2} size={20} />
                                                ) : (
                                                    <BlockTwoToneIcon sx={{ fontSize: '1.1rem' }} />
                                                )}
                                            </IconButton>
                                        </Tooltip>
                                    </Stack>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>

            {userStatus && (
                <AppDialog
                    open={dialog.open}
                    title={userStatus.locked ? 'Activate User' : 'Deactivate User'}
                    description={`Are you sure you want to ${userStatus.locked ? 'activate' : 'deactivate'} ${userStatus.name}?`}
                    isLoading={isAgencyUsersLoading}
                    loadingButtonTitle={userStatus.locked ? 'Activating...' : 'Deactivating...'}
                    Graphic={<Lottie options={defaultOptions} height={100} width={100} />}
                    handleClose={handleClose}
                    handleConfirm={handleConfirm}
                />
            )}

            {selectedUser && editUserId && (
                <EditAgencyUser
                    isOpen={modal.open}
                    agencyName={agencyName}
                    setIsOpen={modal.setOpen}
                    user={selectedUser}
                    id={editUserId}
                    selectedUserRole={selectedUserRole}
                />
            )}
        </TableContainer>
    );
};
